import { useState } from "react";
import { apiEndpoints } from "../config/api";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaTripadvisor,
} from "react-icons/fa";
import contactUs from "../assets/contact.jpg";
import contactUs2 from "../assets/contact2.jpg";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(apiEndpoints.contact, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then(async (response) => {
        if (!response.ok) {
          let errorBody;
          try {
            errorBody = await response.json();
          } catch {
            // ignore JSON parse errors
          }
          console.error(
            "Contact form submission failed:",
            response.status,
            response.statusText,
            errorBody
          );
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("✅ Contact form submitted successfully:", data);
        setSubmitted(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
      })
      .catch((error) => {
        console.error("❌ Error submitting form:", error);
      });
  };

  return (
    <div className="mdc-contact-page bg-[#1a1f28]">
      <section className="mdc-contact-hero">
        <img
          src={contactUs}
          alt="Elephant herd crossing the savannah"
          className="mdc-contact-hero-media  black/10 opacity-80"
        />
        <div className="mdc-contact-hero-content">
          <span className="mdc-contact-kicker">Contact Yala Vibe</span>
          <h1 className="mdc-contact-title">
            Let's design your next wilderness escape.
          </h1>
          <p className="mdc-contact-subtitle">
            Share your travel dreams and we'll tailor Vibe stays, guided drives,
            and transfers around your pace.
          </p>
          <div className="mdc-contact-actions">
            <a href="tel:+94707238259" className="mdc-contact-outline-button">
              Call us
            </a>
            {/* <a
              href="mailto:chinthakabandara455@gmail.com"
              className="mdc-contact-outline-button"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "mailto:chinthakabandara455@gmail.com";
              }}
            >
              Email us
            </a> */}
          </div>
       
        </div>
      </section>

      <div className="mdc-contact-body">
        <section className="mdc-contact-info">
          <div className="mdc-contact-info-card">
            <p className="mdc-contact-info-title">Headquarters</p>
            <h2 className="mdc-contact-info-heading">Visit us</h2>
            <p className="mdc-contact-info-text">
            Yala Vibe , Yala block 01,05,06 <br/>
            Bundala Vibe
            </p>
          </div>
          <div className="mdc-contact-info-card">
            <p className="mdc-contact-info-title">Reservations</p>
            <h2 className="mdc-contact-info-heading">Talk to us</h2>
            <p className="mdc-contact-info-text">
              <a
                href="mailto:info@yalavibe.com"
                className="underline"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "mailto:info@yalavibe.com";
                }}
              >
                info@yalavibe.com
              </a>
              <br />
              <a href="tel:+94707238259" className="underline">
              +9470 723 8259
              </a>
            </p>
          </div>
          <div className="mdc-contact-info-card">
            <p className="mdc-contact-info-title">Community</p>
            <h2 className="mdc-contact-info-heading">Follow our journey</h2>
            <div className="mdc-contact-socials">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noreferrer"
                className="mdc-contact-social-link"
                aria-label="Facebook"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noreferrer"
                className="mdc-contact-social-link"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noreferrer"
                className="mdc-contact-social-link"
                aria-label="Twitter"
              >
                <FaTwitter size={20} />
              </a>
              <a
                href="https://www.tripadvisor.com"
                target="_blank"
                rel="noreferrer"
                className="mdc-contact-social-link"
                aria-label="Tripadvisor"
              >
                <FaTripadvisor size={20} />
              </a>
            </div>
          </div>
        </section>

        <section className="mdc-contact-map-card">
          <div className="mdc-contact-map-header">
            <h2 className="mdc-contact-map-title">Find us in Yala</h2>
          </div>
          <div className="mdc-contact-map-body">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3965.838466354967!2d81.28113367499084!3d6.284953893703984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNsKwMTcnMDUuOCJOIDgxwrAxNycwMS40IkU!5e0!3m2!1sen!2slk!4v1763143309746!5m2!1sen!2slk"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Yala Vibe Location"
            ></iframe>


          </div>
        </section>

        <section className="mdc-contact-main my-5">
          <div className="mdc-contact-form-wrapper">
            <h2 className="mdc-contact-form-title">Send us a message</h2>
            <p className="mdc-contact-form-text">
              Planning your dream Vibe or a serene retreat? Tell us what you have
              in mind—our coordinators will reach out within 24 hours.
            </p>
            <form className="mdc-contact-form" onSubmit={handleSubmit}>
              <div className="mdc-field">
                <label className="mdc-label" htmlFor="name">
                  Name
                </label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  className="mdc-input-rounded"
                  required
                />
              </div>

              <div className="mdc-field">
                <label className="mdc-label" htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="mdc-input-rounded"
                  required
                />
              </div>

              <div className="mdc-field">
                <label className="mdc-label" htmlFor="phone">
                  Phone
                </label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  className="mdc-input-rounded"
                />
              </div>

              <div className="mdc-field">
                <label className="mdc-label" htmlFor="message">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your ideal Vibe"
                  rows="5"
                  className="mdc-textarea-rounded"
                  required
                />
              </div>

              <button type="submit" className="mdc-submit-button">
                Submit enquiry
              </button>
            </form>

            {submitted && (
              <div className="mdc-success-alert">
                Thank you! Your message has been sent successfully.
              </div>
            )}
          </div>

          <div className="mdc-contact-visual">
            <img
              src={contactUs2}
              alt="Vibe jeep spotting a leopard"
              className="mdc-contact-visual-image"
            />
            <div className="mdc-contact-visual-overlay" aria-hidden="true" />
            <div className="mdc-contact-visual-caption">
              <h3 className="mdc-contact-visual-title">Field coordination team</h3>
              <p className="mdc-contact-visual-text">
                Our rangers and guest relations crew are on call to craft smooth
                itineraries, book jeeps, and handle last-minute adjustments.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
